import * as api from "api/Core";
import { GenericLogDialog, GenericLogDialogProps, ILogTranslated } from "components/GenericLogDialog";
import { LogRecord } from "models/ApiModels";
import { withTranslation } from 'react-i18next';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class SetupIntegrationLogDialog extends GenericLogDialog<GenericLogDialogProps> {

    getLog(offset: number, take: number) {
        return api.getSetupIntegrationLog(offset, take);
    }

    translate(data: LogRecord[]): ILogTranslated[] {
        const result: ILogTranslated[] = [];

        data.forEach((v) => {
            var j = v.jsonData;

            Object.keys(j).forEach((key) => {

                const r: ILogTranslated = {
                    name: this.defaultFieldName(key, "SetupIntegration"),
                    creationDate: v.creationDate,
                    creator: v.creator,
                    content: ""
                };

                result.push(r);
            });
        });

        return result;
    }
}

export default withTranslation("log")(SetupIntegrationLogDialog); 